export default __webpack_public_path__ + "static/media/stars.2d0414c5.svg";